import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

const BACK_LABEL = 'Back';

interface BackButtonProps {
  onClick: () => void;
}

export function BackButton({ onClick }: BackButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            type="button"
            variant="outline"
            size="icon"
            aria-label={BACK_LABEL}
            onClick={onClick}
            className="shrink-0 rounded-full"
          />
        }
      >
        <ArrowLeft className="size-4" aria-hidden />
      </TooltipTrigger>
      <TooltipContent>{BACK_LABEL}</TooltipContent>
    </Tooltip>
  );
}
